import React from 'react';
import { CTAButton } from './CTAButton';
import { ShieldCheckIcon, LockIcon, CreditCardIcon, FileTextIcon, ZapIcon, BookOpenIcon } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-gradient-to-br from-[#071A14] to-[#0F2E23] py-4 md:py-6 px-3 relative overflow-hidden border-b-2 border-[#D4A843]" data-id="element-63">
      <div className="max-w-3xl mx-auto text-center relative z-10 flex flex-col items-center" data-id="element-64">
        <h1 className="text-2xl md:text-4xl font-black text-white leading-tight mb-2 uppercase tracking-tight" data-id="element-65">
          🌾 TODO TU SISTEMA DE <br className="hidden md:block" data-id="element-66" />
          <span className="text-[#D4A843]" data-id="element-67">GEOGRAFÍA RURAL</span> RESUELTO
        </h1>

        <div className="my-2 cursor-pointer transform hover:scale-[1.02] transition-transform duration-300 w-full max-w-lg relative" onClick={scrollToPricing} data-id="element-68">
          <div className="absolute inset-0 bg-[#74C69D] opacity-20 blur-2xl rounded-full" data-id="element-69"></div>
          <img src="https://cdn.magicpatterns.com/uploads/azc77Vr3SFRw1TwTSoEze3/mockups_GEOGRAFIA_RURAL_.png" alt="Kit Completo Geografía Rural" className="w-full h-auto relative z-10 rounded-xl" style={{
          boxShadow: '0px 30px 60px rgba(0,0,0,0.6)',
          filter: 'drop-shadow(0 0 30px rgba(116,198,157,0.25))'
        }} data-id="element-70" />
        </div>

        <p className="text-[#BFC9C5] text-sm md:text-base font-bold mb-2 max-w-xl mx-auto leading-snug" data-id="element-71">
          Clases, actividades y evaluaciones listas para que dejes de improvisar
          y enseñes con seguridad.
        </p>

        <div className="bg-[#102A1F] border border-[#D4A843] rounded-lg px-4 py-2 mb-3 inline-block shadow-lg" data-id="element-72">
          <p className="text-white font-black text-sm md:text-base" data-id="element-73">
            👉 Llegás al aula sabiendo exactamente qué enseñar.
          </p>
        </div>

        <div className="flex items-center justify-center gap-4 md:gap-6 mb-3 flex-nowrap" data-id="element-74">
          <div className="flex items-center gap-1.5 text-[#74C69D] text-[10px] md:text-xs font-bold whitespace-nowrap" data-id="element-75">
            <FileTextIcon className="w-3.5 h-3.5 text-[#D4A843]" strokeWidth={2.5} data-id="element-76" />
            PDF DESCARGABLE
          </div>
          <div className="flex items-center gap-1.5 text-[#74C69D] text-[10px] md:text-xs font-bold whitespace-nowrap" data-id="element-77">
            <ZapIcon className="w-3.5 h-3.5 text-[#D4A843]" strokeWidth={2.5} data-id="element-78" />
            ACCESO INMEDIATO
          </div>
          <div className="flex items-center gap-1.5 text-[#74C69D] text-[10px] md:text-xs font-bold whitespace-nowrap" data-id="element-79">
            <BookOpenIcon className="w-3.5 h-3.5 text-[#D4A843]" strokeWidth={2.5} data-id="element-80" />
            CURRÍCULA ARGENTINA
          </div>
        </div>

        <div className="flex justify-center mb-3 w-full max-w-sm" data-id="element-81">
          <CTAButton variant="primary" fullWidth className="py-3 text-sm md:text-base" data-id="element-82">
            QUIERO EL KIT COMPLETO
          </CTAButton>
        </div>

        <div className="flex items-center justify-center gap-3 md:gap-5 text-[#BFC9C5] text-[10px] md:text-xs font-bold mb-3 flex-nowrap" data-id="element-83">
          <div className="flex items-center gap-1 whitespace-nowrap" data-id="element-84">
            <ShieldCheckIcon className="w-3.5 h-3.5 text-[#D4A843]" data-id="element-85" /> Garantía
            7 días
          </div>
          <div className="flex items-center gap-1 whitespace-nowrap" data-id="element-86">
            <LockIcon className="w-3.5 h-3.5 text-[#D4A843]" data-id="element-87" /> Pago 100% seguro
          </div>
          <div className="flex items-center gap-1 whitespace-nowrap" data-id="element-88">
            <CreditCardIcon className="w-3.5 h-3.5 text-[#D4A843]" data-id="element-89" /> Mercado
            Pago | Tarjeta
          </div>
        </div>

        <div className="inline-block bg-[#0B211A] border border-[#1F3D2B] rounded-full px-3 py-1.5 shadow-inner" data-id="element-90">
          <p className="text-[#BFC9C5] text-[10px] md:text-xs font-bold flex items-center gap-1.5" data-id="element-91">
            <span className="text-[#D4A843] text-sm tracking-widest" data-id="element-92">
              ★★★★★
            </span>
            Más de 300 docentes ya tienen sus clases resueltas con este sistema
          </p>
        </div>
      </div>
    </section>;
}